import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { WatchlistType } from "@app2/type-defs/search/search-types";
import { DsSelectOption } from "@app2/shared/components/ds-select.component";

export const editIndicatorReasonByWatchlistType: Record<WatchlistType, DsSelectOption<string>[]> = {
    COUNTRY: [{
        key: "ADD_INDICATOR_REASON_HIGH_RISK_COUNTRY",
        value: "High-risk Country",
    }, {
        key: "ADD_INDICATOR_REASON_OFAC",
        value: "OFAC",
    }],
    EMAIL: [{
        key: "ADD_INDICATOR_REASON_MONEY_MULE",
        value: "Money Mule",
    }, {
        key: "ADD_INDICATOR_REASON_ATO_ATTACKER",
        value: "ATO Attacker",
    }, {
        key: "ADD_INDICATOR_REASON_OAO_ATTACKER",
        value: "OAO Attacker",
    }],
    FI_ROUTING_NUMBER: [{
        key: "ADD_INDICATOR_REASON_HIGH_RISK_FI",
        value: "High-risk FI",
    }],
    IP_ADDRESS: [{
        key: "ADD_INDICATOR_REASON_HIGH_RISK_IP",
        value: "High-risk IP",
    }, {
        key: "ADD_INDICATOR_REASON_VPN",
        value: "VPN",
    }, {
        key: "ADD_INDICATOR_REASON_AGGREGATOR",
        value: "Aggregator",
    }],
    IP_CIDR: [{
        key: "ADD_INDICATOR_REASON_HIGH_RISK_IP",
        value: "High-risk IP",
    }, {
        key: "ADD_INDICATOR_REASON_VPN",
        value: "VPN",
    }, {
        key: "ADD_INDICATOR_REASON_AGGREGATOR",
        value: "Aggregator",
    }],
    OTHER: [{
        key: "ADD_INDICATOR_REASON_OTHER",
        value: "Other",
    }],
    PHONE_NUMBER: [{
        key: "ADD_INDICATOR_REASON_MONEY_MULE",
        value: "Money Mule",
    }, {
        key: "ADD_INDICATOR_REASON_ATO_ATTACKER",
        value: "ATO Attacker",
    }, {
        key: "ADD_INDICATOR_REASON_OAO_ATTACKER",
        value: "OAO Attacker",
    }],
};
@Component({
    selector: "add-indicators-reason",
    template: `
        <label *ngIf="communityWatchlist; else reasonTextArea">
            <span class="required-asterisk">*</span> {{ "ADD_INDICATOR_REASON" | localize }}
            <ds-select [selectedOption]="reason"
                       (selectedOptionChange)="reasonChange.emit($event)"
                       [options]="reasonOptions"
                       test-id="reason-dropdown">
            </ds-select>
        </label>
        <ng-template #reasonTextArea>
            <label>
                {{ "ADD_INDICATOR_REASON" | localize }}
                <textarea name="add-reason"
                          [ngModel]="reason"
                          (ngModelChange)="reasonChange.emit($event)"
                          test-id="reason-textarea"></textarea>
            </label>
        </ng-template>
    `,
})
export class AddIndicatorsReasonComponent implements OnChanges {
    @Input() communityWatchlist: boolean;
    @Input() type: WatchlistType;

    @Input() reason: string;
    @Output() reasonChange = new EventEmitter<string>();

    reasonOptions: DsSelectOption<string>[];

    ngOnChanges(changes: SimpleChanges) {
        if (this.communityWatchlist && changes.type) {
            this.reasonOptions = editIndicatorReasonByWatchlistType[this.type];
        }
    }
}